import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"

export const forgetPasswordViaEmailApi = createAsyncThunk(
    'auth/forget-password-via-email',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(`api/v1/login/forget_pass_token/`, { type: 'email', ...data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const forgetPasswordViaEmailSlice = createSlice({
    name: 'forget-password-via-email',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(forgetPasswordViaEmailApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(forgetPasswordViaEmailApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(forgetPasswordViaEmailApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const forgetPasswordViaEmailReducer = forgetPasswordViaEmailSlice.reducer